import { makeStyles } from '@material-ui/core/styles';
import { vh, em } from 'src/common/helpers/dimension-helper';
import { themeColor } from '../../../mui-theme';

export const styles = makeStyles(theme => ({
  component: {
    height: '100%',
  },
  transactions: {
    height: '48vh',
    overflowY: 'auto',
    padding: '1.25vh 2.67vh',
  },
  transactionItemContainer: {
    position: 'relative',
    height: '7.29vh',
    backgroundColor: themeColor.white,
    boxShadow: `0 1px 4px 0 ${themeColor.almosttransparentblack}`,
    border: '2px solid',
    cursor: 'pointer',
    marginBottom: 12,
  },
  transactionItemCheck: {
    position: 'absolute',
    color: theme.palette.primary.main,
    width: 28,
    top: -10,
    left: -19,
  },
  transactionNameContainer: {
    width: '18.58vw',
    justifyContent: 'flex-start',
  },
  transactionImage: {
    width: '2.19vw',
    height: '4.68vh',
    paddingLeft: 0,
  },
  transactionSequenceNumber: {
    width: '18.59vw',
    height: '3.12vh',
    fontFamily: '"Roboto", Helvetica, Arial, sans-serif',
    fontSize: vh(2.34),
    fontWeight: 'normal',
    fontStretch: 'normal',
    fontStyle: 'normal',
    lineHeight: 1.33,
    letterSpacing: 0.15,
    color: themeColor.almostblack,
    overflow: 'hidden',
  },
  transactionItemName: {
    width: '18.59vw',
    height: '2.6vh',
    fontFamily: '"Roboto", Helvetica, Arial, sans-serif',
    fontSize: vh(1.82),
    fontWeight: 'normal',
    fontStretch: 'normal',
    fontStyle: 'normal',
    lineHeight: 1.43,
    letterSpacing: 0.25,
    color: themeColor.blackish,
  },
  transactionDate: {
    height: '3.12vh',
    fontFamily: '"Roboto", Helvetica, Arial, sans-serif',
    fontSize: vh(2.34),
    fontWeight: 'normal',
    fontStretch: 'normal',
    fontStyle: 'normal',
    lineHeight: 1.33,
    letterSpacing: 0.17,
    color: themeColor.almostblack,
  },
  transactionTotal: {
    width: '30.31vw',
    height: '3.12vh',
    fontFamily: '"Roboto", Helvetica, Arial, sans-serif',
    fontSize: vh(2.34),
    fontWeight: 'normal',
    fontStretch: 'normal',
    fontStyle: 'normal',
    lineHeight: 1.33,
    letterSpacing: 0.17,
    textAlign: 'right',
    paddingRight: '0 1.61vw',
    color: themeColor.almostblack,
  },
  transactionMessage: {
    fontSize: em(18),
    fontFamily: '"Roboto", Helvetica, Arial, sans-serif',
    fontWeight: 'normal',
    fontStretch: 'normal',
    fontStyle: 'normal',
    lineHeight: 1.56,
    letterSpacing: '0.56px',
    color: themeColor.blackish,
  },
}));
